import { useDispatch, useSelector } from "react-redux";
import { downloadDeliveryReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";

export const useDeliveryReportDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.clearing.deliveries.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadDeliveryReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
